<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
    	<path fill="#666" fill-rule="evenodd" d="M1.545.352C1.295-.024.765-.104.376.137-.014.38-.097.888.154 1.264a.59.59 0 0 0 .11.134l4.537 5.07-4.536 5.15a.759.759 0 0 0-.028 1.127.828.828 0 0 0 1.169.027c.056-.054.083-.08.111-.135L7 6.441 1.545.351z"/>
	</svg>
</template>
<script>
export default { name: 'section-item-arrow' }
</script>
